import PlansListPanel from "./plans-list-panel";
import UsersByPlanPanel from "./users-by-plan-panel";

const MobPlans = () => {

    return (
        <>
            <div className={"w-100 d-flex flex-row align-items-center justify-content-center gap-3"}>
                <div className={"w-25 h-100 d-flex flex-column align-items-center align-self-start"}>
                    <PlansListPanel/>
                </div>
                <div className={"w-75 h-100 d-flex flex-column align-items-center align-self-start"}>
                    <UsersByPlanPanel/>
                </div>
            </div>
        </>
    );
};
export default MobPlans;
